var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { Entity } from '../../entity/Entity';
import { deserialize } from '../../../utils/serializr/serializr';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { editable } from '../../../utils/mobx/decorators/editable';
export class MedSeq extends Entity {
    type = 'medseq';
    mediumLabel = '';
    sequenceName = '';
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get sequenceLabel() {
        return `${this.mediumLabel}_${this.sequenceName}`;
    }
    get trait() {
        return this.parent;
    }
    get aspect() {
        return this.parent.aspect;
    }
    static fromSerialized(ser = { mediumLabel: '', sequenceName: '' }) {
        return deserialize(MedSeq, ser);
    }
    static get serializeInfo() {
        return {
            extends: Entity.serializeInfo,
            props: {
                mediumLabel: true,
                sequenceName: true,
            },
        };
    }
}
__decorate([
    editable()
], MedSeq.prototype, "mediumLabel", void 0);
__decorate([
    editable()
], MedSeq.prototype, "sequenceName", void 0);
__decorate([
    computed
], MedSeq.prototype, "sequenceLabel", null);
__decorate([
    memoize
], MedSeq, "serializeInfo", null);
